import { h, render, Component } from 'preact';
import { Link } from 'preact-router/match';
import { translate } from 'react-i18next';

import Button from './Button.js';


class GameOverviewCard extends Component {

	hideInfo = () => {
		if (this.state.currency !== '0') {
			this.setState({ currency: true });
		}
		else if (this.state.game !== '') {
			this.setState({ download: true });
			this.setState({ refer: true });			
		}
	}

	checkRefer = () => {
		if (this.state.game === 'tactics' || this.state.game === 'realm') {
			this.setState({ refer: false });
		}
	}

	constructDownloadLink = (game) => {
		switch (game) {
			case 'smite':
				this.setState({ downloadLink: 'https://www.smitegame.com/download' });
			break;
			case 'paladins':
				this.setState({ downloadLink: 'https://www.paladins.com/download' });
			break;
			case 'tactics':
				this.setState({ downloadLink: 'http://cds.q6u4m8x5.hwcdn.net/Installs/InstallSmiteTactics.exe' });
			break;
			case 'realm-royale':
				this.setState({ downloadLink: 'https://www.realmroyale.com/sign-up' });
			break;
		}
	}

	constructor(props) {
		super();
		this.state = {
			game: props.game || '',
			refer: true,
			downloadLink: undefined
		};
	}

	componentDidMount() {
		this.hideInfo();
		this.checkRefer();
		this.constructDownloadLink(this.props.game);
	}
 
	render() {
		const { t } = this.props;
		return (
			<div className="game-container">
				<div className="center">
					<div className="game-logo">
						<img src={`https://webcdn.hirezstudios.com/account-services/logo-${this.props.game}.png`} />
					</div>
					<p className="username">{this.props.name}</p>
					<div className="links-container">
						<a href={this.state.downloadLink}>
							<Button
								color="blue"
								copy={t('Download')}
							/>
						</a>
						<Link className={this.state.refer === false ? 'is-disabled' : ''} href={`/refer/${this.props.game}`}>
							<Button
								color="blue"
								copy={t('Refer a Friend')}
							/>
						</Link>
					</div>
				</div>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(GameOverviewCard);



// WEBPACK FOOTER //
// ./components/GameOverviewCard.js